// All service content — the SEO heart of the site.
// Each entry powers a dedicated, keyword-rich landing page.

export const SERVICES = [
  {
    slug: "chiptuning-cloppenburg",
    icon: "Gauge",
    world: "tuning",
    nav: "Chiptuning",
    eyebrow: "Leistung & Effizienz",
    h1: "Chiptuning Cloppenburg",
    metaTitle: "Chiptuning Cloppenburg | Mehr PS & Drehmoment | KeyMaster KFZ",
    metaDescription:
      "Professionelles Chiptuning im Raum Cloppenburg. Mehr Leistung, mehr Drehmoment & spürbar besserer Durchzug bei optimiertem Verbrauch. Jetzt Termin sichern bei KeyMaster KFZ.",
    image:
      "https://images.unsplash.com/photo-1519752594763-2633d8d4ea29?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Du willst mehr Leistung aus deinem Fahrzeug holen – ohne teure Hardware-Umbauten? Unser Chiptuning im Raum Cloppenburg optimiert die Motorsteuerung deines Autos individuell und sicher. Mehr Drehmoment, kraftvollerer Durchzug und ein direkteres Ansprechverhalten – bei sachgemäßer Fahrweise sogar mit reduziertem Verbrauch.",
    benefits: [
      { title: "Mehr PS & Drehmoment", desc: "Spürbares Leistungsplus durch optimierte Kennfelder – perfekt abgestimmt auf Motor und Getriebe." },
      { title: "Weniger Verbrauch möglich", desc: "Effizientere Verbrennung senkt bei gleichbleibender Fahrweise oft den Kraftstoffverbrauch." },
      { title: "Individuell abgestimmt", desc: "Kein Standard-File von der Stange – jede Abstimmung wird auf dein Fahrzeug angepasst." },
      { title: "Reversibel & sicher", desc: "Serienstand jederzeit wiederherstellbar. Wir arbeiten innerhalb sicherer Toleranzen." },
    ],
    process: [
      { title: "Auslesen & Analyse", desc: "Wir lesen das originale Steuergerät aus und prüfen den Ist-Zustand deines Fahrzeugs." },
      { title: "Individuelle Abstimmung", desc: "Erstellung eines optimierten Kennfelds – abgestimmt auf Leistung, Effizienz und Langlebigkeit." },
      { title: "Aufspielen & Test", desc: "Die neue Software wird aufgespielt und im Fahrbetrieb geprüft." },
      { title: "Übergabe & Beratung", desc: "Du bekommst eine ehrliche Beratung zu Eintragung, Versicherung und Wartung." },
    ],
    faq: [
      { q: "Wie viel mehr Leistung ist realistisch?", a: "Je nach Motor sind bei Turbomotoren häufig 20–30 % mehr Leistung und Drehmoment möglich. Wir nennen dir vorab realistische Werte für dein Fahrzeug." },
      { q: "Muss ich das Tuning eintragen lassen?", a: "In vielen Fällen ist eine Eintragung erforderlich. Wir beraten dich transparent zu Prüforganisationen und Versicherung im Raum Cloppenburg." },
      { q: "Geht der Serienzustand verloren?", a: "Nein. Wir sichern die Originaldaten, sodass der Serienstand jederzeit wiederhergestellt werden kann." },
    ],
    keywords: ["Chiptuning Cloppenburg", "Leistungssteigerung", "Kennfeldoptimierung", "Mehr PS Cloppenburg", "Stage 1 Cloppenburg", "Stage 3 Tuning", "Öldruck Fix", "Pops and Bangs", "Leistungsmessung Prüfstand", "DynoPro Cloppenburg", "DPF Lösung", "AGR Lösung", "SCR AdBlue"],
  },
  {
    slug: "softwareoptimierung-cloppenburg",
    icon: "Cpu",
    world: "tuning",
    nav: "Softwareoptimierung",
    eyebrow: "ECU Software",
    h1: "Softwareoptimierung Cloppenburg",
    metaTitle: "Softwareoptimierung Cloppenburg | ECU Tuning | KeyMaster KFZ",
    metaDescription:
      "Softwareoptimierung & ECU-Tuning im Raum Cloppenburg: OPF/DPF-Themen, AdBlue, Laufkultur & Ansprechverhalten. Individuell, sicher und professionell von KeyMaster KFZ.",
    image:
      "https://images.unsplash.com/photo-1517524008697-84bbe3c3fd98?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Moderne Fahrzeuge werden über die Motorsteuerung (ECU) gesteuert. Mit einer professionellen Softwareoptimierung im Raum Cloppenburg holen wir mehr Laufkultur, besseres Ansprechverhalten und ein harmonischeres Fahrgefühl aus deinem Auto – exakt auf deine Wünsche abgestimmt.",
    benefits: [
      { title: "Feineres Ansprechverhalten", desc: "Optimierte Gaspedalkennlinie und Lastwechsel für ein direkteres Fahrgefühl." },
      { title: "Mehr Laufruhe", desc: "Harmonischere Abstimmung von Ladedruck, Einspritzung und Zündung." },
      { title: "Maßgeschneidert", desc: "Ob sparsam, sportlich oder ausgewogen – die Software wird nach deinem Wunsch abgestimmt." },
      { title: "Datensicherung inklusive", desc: "Original-Software wird gesichert und kann jederzeit zurückgespielt werden." },
    ],
    process: [
      { title: "Fahrzeug-Check", desc: "Auslesen der Steuergeräte und Fehlerspeicher-Analyse." },
      { title: "Zieldefinition", desc: "Wir besprechen dein Ziel: Effizienz, Leistung oder Komfort." },
      { title: "Optimierung", desc: "Anpassung der relevanten Kennfelder durch erfahrene Abstimmung." },
      { title: "Qualitätskontrolle", desc: "Funktionsprüfung und Testfahrt vor der Übergabe." },
    ],
    faq: [
      { q: "Was ist der Unterschied zum Chiptuning?", a: "Chiptuning zielt primär auf Mehrleistung. Softwareoptimierung ist der Oberbegriff und umfasst auch Komfort-, Effizienz- und Laufkultur-Optimierungen." },
      { q: "Bleibt die Zuverlässigkeit erhalten?", a: "Ja. Wir arbeiten innerhalb sicherer Grenzen und legen Wert auf langlebige, alltagstaugliche Abstimmungen." },
      { q: "Für welche Marken bietet ihr das an?", a: "Marken- und modellübergreifend – von VW, Audi und BMW über Mercedes bis hin zu Ford, Opel und vielen mehr." },
    ],
    keywords: ["Softwareoptimierung Cloppenburg", "ECU Tuning", "Motorsteuerung optimieren", "Stage 1 Stage 2 Stage 3", "Öldruck Fix", "Pops and Bangs", "Leistungsmessung DynoPro", "DPF OPF Lösung", "AGR Lösung", "SCR AdBlue Lösung"],
  },
  {
    slug: "steuergeraet-reparatur",
    icon: "CircuitBoard",
    world: "tuning",
    nav: "Steuergerät-Reparatur",
    eyebrow: "Elektronik & Diagnose",
    h1: "Steuergeräte-Reparatur Cloppenburg",
    metaTitle: "Steuergerät Reparatur Cloppenburg | ECU Instandsetzung | KeyMaster",
    metaDescription:
      "Steuergeräte-Reparatur im Raum Cloppenburg statt teurem Austausch. Motorsteuergerät, Getriebesteuergerät & Elektronik professionell instandgesetzt. KeyMaster KFZ.",
    image:
      "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Ein defektes Steuergerät muss nicht das teure Aus bedeuten. Statt eines kompletten Austauschs reparieren wir dein Motor- oder Getriebesteuergerät im Raum Cloppenburg fachgerecht – das spart bares Geld und die aufwändige Neucodierung entfällt oft komplett.",
    benefits: [
      { title: "Günstiger als Austausch", desc: "Reparatur statt Neuteil – häufig nur ein Bruchteil der Kosten eines neuen Steuergeräts." },
      { title: "Keine Neucodierung nötig", desc: "Da das Originalgerät erhalten bleibt, entfällt meist eine aufwändige Anpassung." },
      { title: "Fundierte Diagnose", desc: "Präzise Fehlersuche auf Bauteilebene statt teurem Rätselraten." },
      { title: "Schnelle Abwicklung", desc: "Kurze Durchlaufzeiten, damit dein Fahrzeug schnell wieder einsatzbereit ist." },
    ],
    process: [
      { title: "Fehlerdiagnose", desc: "Auslesen und Eingrenzen des Defekts am Steuergerät." },
      { title: "Bauteilprüfung", desc: "Prüfung der Platine, Lötstellen und Bauteile auf Fehler." },
      { title: "Instandsetzung", desc: "Fachgerechte Reparatur der defekten Komponenten." },
      { title: "Funktionstest", desc: "Vollständiger Test vor dem Wiedereinbau ins Fahrzeug." },
    ],
    faq: [
      { q: "Welche Steuergeräte repariert ihr?", a: "Unter anderem Motorsteuergeräte (ECU), Getriebesteuergeräte und weitere KFZ-Elektronik. Frag einfach für dein konkretes Bauteil an." },
      { q: "Wie lange dauert eine Reparatur?", a: "Je nach Defekt und Verfügbarkeit oft nur wenige Werktage. Bei der Anfrage nennen wir dir eine konkrete Einschätzung." },
      { q: "Gibt es Garantie auf die Reparatur?", a: "Ja, auf unsere Instandsetzungen gewähren wir eine faire Gewährleistung. Details klären wir vorab." },
    ],
    keywords: ["Steuergerät Reparatur Cloppenburg", "ECU Instandsetzung", "Motorsteuergerät defekt"],
  },
  {
    slug: "wegfahrsperre-deaktivieren",
    icon: "ShieldOff",
    world: "tuning",
    nav: "Wegfahrsperre",
    eyebrow: "Immobilizer",
    h1: "Wegfahrsperre – Cloppenburg",
    metaTitle: "Wegfahrsperre Cloppenburg | Immobilizer Problem lösen | KeyMaster",
    metaDescription:
      "Probleme mit der Wegfahrsperre im Raum Cloppenburg? Wir lösen Immobilizer-Fehler, lernen Schlüssel an und bringen dein Fahrzeug wieder zum Starten. KeyMaster KFZ.",
    image:
      "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Springt dein Auto nicht mehr an, weil die Wegfahrsperre blockiert? Ob defekter Transponder, verlorener Schlüssel oder Elektronikfehler – im Raum Cloppenburg diagnostizieren wir das Problem an der Wegfahrsperre und bringen dein Fahrzeug wieder sicher zum Laufen.",
    benefits: [
      { title: "Fahrzeug startet wieder", desc: "Wir beheben Immobilizer-Fehler, damit dein Auto zuverlässig anspringt." },
      { title: "Schlüssel neu anlernen", desc: "Neue oder vorhandene Schlüssel werden fachgerecht an die Wegfahrsperre angelernt." },
      { title: "Präzise Diagnose", desc: "Klare Fehlereingrenzung statt teurem Bauteil-Tausch auf Verdacht." },
      { title: "Mobil vor Ort", desc: "Viele Arbeiten führen wir direkt bei dir vor Ort durch – schnell und unkompliziert." },
    ],
    process: [
      { title: "Diagnose", desc: "Auslesen der Wegfahrsperre und Analyse der Fehlerursache." },
      { title: "Lösungsweg", desc: "Wir erklären dir transparent, was zu tun ist und was es kostet." },
      { title: "Umsetzung", desc: "Anlernen von Schlüsseln bzw. Beheben des Elektronikfehlers." },
      { title: "Funktionstest", desc: "Wir prüfen den sicheren Start und übergeben das Fahrzeug." },
    ],
    faq: [
      { q: "Mein Schlüssel ist weg – könnt ihr helfen?", a: "Ja. Wir können auch bei komplett verlorenen Schlüsseln einen neuen Schlüssel anlernen und die Wegfahrsperre wieder freigeben." },
      { q: "Arbeitet ihr markenübergreifend?", a: "Ja, wir betreuen nahezu alle gängigen Marken und Modelle im Raum Cloppenburg." },
      { q: "Ist das legal?", a: "Ja – Arbeiten an der Wegfahrsperre für den rechtmäßigen Fahrzeughalter sind selbstverständlich zulässig. Ein Eigentumsnachweis kann erforderlich sein." },
    ],
    keywords: ["Wegfahrsperre Cloppenburg", "Immobilizer Fehler", "Auto startet nicht Wegfahrsperre"],
  },
  {
    slug: "schluesseldienst-cloppenburg",
    icon: "KeyRound",
    world: "key",
    nav: "Schlüsseldienst",
    eyebrow: "Mobiler KFZ-Service",
    h1: "KFZ-Schlüsseldienst Cloppenburg",
    metaTitle: "Schlüsseldienst Cloppenburg | Mobiler KFZ Service | KeyMaster KFZ",
    metaDescription:
      "Mobiler KFZ-Schlüsseldienst im Raum Cloppenburg. Autoschlüssel nachmachen, anlernen & Notöffnung – schnell direkt vor Ort. Fair, zuverlässig, 24/7. KeyMaster KFZ.",
    image:
      "https://images.pexels.com/photos/333837/pexels-photo-333837.jpeg?auto=compress&cs=tinysrgb&w=1600",
    intro:
      "Dein mobiler KFZ-Schlüsseldienst im Raum Cloppenburg. Wir kommen direkt zu dir – ob Autoschlüssel nachmachen, Schlüssel anlernen oder Notöffnung. Flexibel, schnell und ohne teuren Abschleppdienst zur Vertragswerkstatt. Auch dann, wenn alle Schlüssel verloren sind.",
    benefits: [
      { title: "Mobil direkt vor Ort", desc: "Wir kommen zu dir nach Hause, zur Arbeit oder an den Pannenort – im ganzen Raum Cloppenburg." },
      { title: "Markenunabhängig", desc: "Vom Kleinwagen bis zur Oberklasse: Wir arbeiten marken- und modellübergreifend." },
      { title: "Faire Preise", desc: "Transparente Kosten ohne versteckte Gebühren – klare Ansage vor dem Einsatz." },
      { title: "24/7 Notdienst", desc: "Auch abends, am Wochenende und an Feiertagen für dich erreichbar." },
    ],
    process: [
      { title: "Anruf / WhatsApp", desc: "Du schilderst dein Problem, wir nennen dir Preis und Ankunftszeit." },
      { title: "Anfahrt", desc: "Wir kommen mobil mit der passenden Technik direkt zu dir." },
      { title: "Service vor Ort", desc: "Schlüssel anlernen, nachmachen oder Notöffnung – direkt am Fahrzeug." },
      { title: "Fertig & mobil", desc: "Du bist wieder unterwegs – schnell und ohne Umwege." },
    ],
    faq: [
      { q: "Kommt ihr wirklich zu mir?", a: "Ja, wir sind ein mobiler Service und kommen im gesamten Raum Cloppenburg direkt zu dir." },
      { q: "Was, wenn ich alle Schlüssel verloren habe?", a: "Kein Problem – wir können auch ohne vorhandenen Schlüssel einen neuen anlernen." },
      { q: "Wie schnell seid ihr da?", a: "Im Notfall sind wir oft innerhalb einer Stunde vor Ort. Die genaue Zeit nennen wir dir bei der Anfrage." },
    ],
    keywords: ["Schlüsseldienst Cloppenburg", "KFZ Schlüsseldienst", "mobiler Autoschlüsseldienst"],
  },
  {
    slug: "auto-notoeffnung",
    icon: "Unlock",
    world: "key",
    emergency: true,
    nav: "Notöffnung",
    eyebrow: "24/7 Notfall",
    h1: "Auto-Notöffnung Cloppenburg",
    metaTitle: "Auto Notöffnung Cloppenburg | 24/7 Türöffnung ohne Schaden | KeyMaster",
    metaDescription:
      "Ausgesperrt? Auto-Notöffnung im Raum Cloppenburg – 24/7, schnell und ohne Beschädigung. Auch bei eingeschlossenem Kind oder Haustier. Jetzt anrufen: KeyMaster KFZ.",
    image:
      "https://images.pexels.com/photos/12066287/pexels-photo-12066287.jpeg?auto=compress&cs=tinysrgb&w=1600",
    intro:
      "Ausgesperrt oder Schlüssel im verschlossenen Auto? Unsere Auto-Notöffnung im Raum Cloppenburg hilft dir 24/7 – schnell, professionell und in aller Regel ohne Beschädigung. Besonders wichtig: Auch bei eingeschlossenem Kind oder Haustier sind wir sofort für dich da.",
    benefits: [
      { title: "Ohne Beschädigung", desc: "Professionelle Öffnungstechnik – schonend für Schloss und Fahrzeug." },
      { title: "Sofort-Hilfe 24/7", desc: "Notfälle warten nicht. Wir sind rund um die Uhr für dich erreichbar." },
      { title: "Schnelle Anfahrt", desc: "Kurze Reaktionszeiten im gesamten Raum Cloppenburg." },
      { title: "Notfall Kind/Tier", desc: "Bei akuter Gefahr für eingeschlossene Personen oder Tiere handeln wir sofort." },
    ],
    process: [
      { title: "Sofort anrufen", desc: "Ruf uns an – bei akuter Gefahr für Kind oder Tier zusätzlich 112." },
      { title: "Express-Anfahrt", desc: "Wir machen uns umgehend auf den Weg zu deinem Standort." },
      { title: "Schonende Öffnung", desc: "Fachgerechte Notöffnung ohne Beschädigung des Fahrzeugs." },
      { title: "Weiterhilfe", desc: "Auf Wunsch prüfen wir direkt Schlüssel und Schloss mit." },
    ],
    faq: [
      { q: "Entsteht bei der Öffnung ein Schaden?", a: "In aller Regel nicht. Wir arbeiten mit spezieller Technik, die das Fahrzeug schont." },
      { q: "Kind im Auto eingeschlossen – was tun?", a: "Bei akuter Gefahr immer zuerst 112 rufen. Parallel kommen wir schnellstmöglich zur schonenden Öffnung." },
      { q: "Seid ihr auch nachts erreichbar?", a: "Ja, unser Notdienst ist 24/7 aktiv – auch nachts, am Wochenende und an Feiertagen." },
    ],
    keywords: ["Auto Notöffnung Cloppenburg", "ausgesperrt Auto", "Türöffnung KFZ 24 Stunden"],
  },
  {
    slug: "kfz-codierungen",
    icon: "Binary",
    world: "tuning",
    nav: "Codierungen",
    eyebrow: "Komfort & Retrofit",
    h1: "KFZ-Codierungen Cloppenburg",
    metaTitle: "KFZ Codierungen Cloppenburg | Freischaltungen & Retrofit | KeyMaster",
    metaDescription:
      "KFZ-Codierungen & Freischaltungen im Raum Cloppenburg: Komfortfunktionen aktivieren, Nachrüstungen anlernen, versteckte Features freischalten. Professionell von KeyMaster KFZ.",
    image:
      "https://images.unsplash.com/photo-1581092160562-40aa08e78837?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Viele Fahrzeuge bringen ab Werk Funktionen mit, die einfach nicht freigeschaltet sind. Mit unseren KFZ-Codierungen im Raum Cloppenburg aktivieren wir Komfortfunktionen, binden Nachrüstungen sauber ein und passen dein Fahrzeug an deine Wünsche an.",
    benefits: [
      { title: "Versteckte Features", desc: "Freischaltung ab Werk vorhandener, aber deaktivierter Komfortfunktionen." },
      { title: "Nachrüstungen einbinden", desc: "Sauberes Anlernen und Codieren von nachgerüsteten Komponenten." },
      { title: "Individuell", desc: "Dein Fahrzeug nach deinen Vorstellungen – von Beleuchtung bis Komfort." },
      { title: "Fachgerecht", desc: "Codierung mit passender Technik, damit die Elektronik stabil bleibt." },
    ],
    process: [
      { title: "Wunsch besprechen", desc: "Du sagst uns, welche Funktion du dir wünschst." },
      { title: "Machbarkeit prüfen", desc: "Wir prüfen, was bei deinem Modell möglich ist." },
      { title: "Codierung", desc: "Fachgerechte Freischaltung bzw. Einbindung der Funktion." },
      { title: "Kontrolle", desc: "Test aller Funktionen vor der Übergabe." },
    ],
    faq: [
      { q: "Welche Funktionen lassen sich codieren?", a: "Das ist stark modellabhängig – z. B. Komfortfunktionen, Beleuchtung, Anzeigen oder Nachrüstungen. Frag für dein Fahrzeug an." },
      { q: "Bleibt die Garantie erhalten?", a: "Codierungen sind in der Regel reversibel. Wir beraten dich zu möglichen Auswirkungen vorab." },
      { q: "Ist das reversibel?", a: "Ja, die meisten Codierungen lassen sich wieder auf den Ausgangszustand zurücksetzen." },
    ],
    keywords: ["KFZ Codierungen Cloppenburg", "Freischaltung Komfortfunktionen", "Codieren Auto"],
  },
  {
    slug: "kfz-schluessel-nachmachen",
    icon: "Key",
    world: "key",
    nav: "KFZ-Schlüssel",
    eyebrow: "Schlüssel & Transponder",
    h1: "KFZ-Schlüssel nachmachen Cloppenburg",
    metaTitle: "Autoschlüssel nachmachen Cloppenburg | Ersatzschlüssel | KeyMaster KFZ",
    metaDescription:
      "Autoschlüssel nachmachen & anlernen im Raum Cloppenburg: Transponder, Funkschlüssel & Keyless-Go. Ersatzschlüssel mobil direkt am Fahrzeug – auch bei Totalverlust. KeyMaster KFZ.",
    image:
      "https://images.unsplash.com/photo-1609205807107-e8ec2120f9de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Ersatzschlüssel gefällig oder Schlüssel verloren? Wir machen deinen KFZ-Schlüssel im Raum Cloppenburg nach – vom einfachen Transponder über den Funk-Klappschlüssel bis zum modernen Keyless-Go-Smart-Schlüssel. Alles mobil und direkt am Fahrzeug angelernt, auch wenn kein Originalschlüssel mehr vorhanden ist.",
    benefits: [
      { title: "Alle Schlüsseltypen", desc: "Transponder, Funkschlüssel, Klappschlüssel und Keyless-Go / Smart-Key." },
      { title: "Direkt am Auto angelernt", desc: "Programmierung am Fahrzeug – der neue Schlüssel funktioniert sofort." },
      { title: "Auch bei Totalverlust", desc: "Neuer Schlüssel selbst dann, wenn alle Schlüssel verloren gegangen sind." },
      { title: "Günstiger als Werkstatt", desc: "Oft deutlich preiswerter als der Weg über die Vertragswerkstatt." },
    ],
    process: [
      { title: "Fahrzeugdaten", desc: "Du nennst uns Marke, Modell und Baujahr für ein Angebot." },
      { title: "Passenden Rohling", desc: "Wir bringen den passenden Schlüssel bzw. Transponder mit." },
      { title: "Anlernen", desc: "Programmierung und Anlernen des Schlüssels direkt am Fahrzeug." },
      { title: "Übergabe", desc: "Funktionstest von Zündung, Funk und Wegfahrsperre." },
    ],
    faq: [
      { q: "Kann ein Keyless-Go-Schlüssel nachgemacht werden?", a: "Ja. Wir ersetzen und programmieren auch moderne Keyless-Go- und Smart-Schlüssel." },
      { q: "Brauche ich den Originalschlüssel?", a: "Nicht zwingend – wir können auch ohne vorhandenen Schlüssel einen neuen anlernen." },
      { q: "Was benötigt ihr von mir?", a: "In der Regel einen Fahrzeug- und Eigentumsnachweis sowie die Fahrzeugdaten. Details klären wir bei der Anfrage." },
    ],
    keywords: ["Autoschlüssel nachmachen Cloppenburg", "KFZ Schlüssel Ersatz", "Keyless Go Schlüssel"],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
export const KEY_SERVICES = SERVICES.filter((s) => s.world === "key");
export const TUNING_SERVICES = SERVICES.filter((s) => s.world === "tuning");
